export const visit = (vm, at) => {
at({ "fr": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Une erreur de connexion au r\xE9seau est survenue.", "message": "V\xE9rifiez votre connexion et r\xE9essayez.", "button": "R\xE9essayer" } } } } });
};